import React, { useState, useRef, useEffect } from 'react'
import Button from '../Button'
import CautionDangerIcon from '../Icons/CautionDangerIcon'

type OTPProps = {
  onSubmit: (code: string) => void;
  error?: string;
  disabled?: boolean;
  isLoading?: boolean;
  isSuccess?: boolean; 
  onClearError?: () => void;
}

export default function OTP({onSubmit, error, disabled, isLoading, isSuccess, onClearError}: OTPProps) {
  const [otp, setOtp] = useState(['', '', '', '', '', '']);
  const inputRefs = useRef<HTMLInputElement[]>([]);

  useEffect(() => {
    inputRefs.current[0]?.focus();
  }, []);
useEffect(() => {
  if (isSuccess) {
    setOtp([]);
  }
  return () => {};
}, [isSuccess]);

  const handleChange = (index: number, value: string) => {
    if (isNaN(Number(value))) return;
    if (error && onClearError) onClearError();

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value !== '' && index < 5) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (index: number, e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Backspace' && index > 0 && otp[index] === '') {
      inputRefs.current[index - 1]?.focus();
    }
  };

  const handleSubmit = () => {
    const code = otp.join('');
    if (code.length === 6) {
      onSubmit(code);
    }
  };

  //Cretet a function to handle paste event
  const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData('text');
    if (!/^\d+$/.test(pastedData)) return;
    if (error && onClearError) onClearError();

    const pastedDigits = pastedData.split('').slice(0, otp.length);
    const updatedOtp = [...otp];

    pastedDigits.forEach((digit, index) => {
        updatedOtp[index] = digit;
    });

    setOtp(updatedOtp);
    const nextIndex = pastedDigits.length < otp.length ? pastedDigits.length : otp.length - 1;
    inputRefs.current[nextIndex]?.focus();
};
  const errorMessage = error?.trim() ?? "";
  const hasError = errorMessage.length > 0;

  return (
    <div className='flex flex-col items-center gap-[20px]'>
        <div className='flex flex-row items-center gap-[16px]'>
            {otp.map((digit, index) => (
              <input
                key={index}
                ref={el => inputRefs.current[index] = el as HTMLInputElement}
                className={`w-[51.67px] h-[56px] rounded-[4px] p-[15px] text-center text-base transition-colors focus:outline-none ${
                  hasError
                    ? 'border-2 border-danger focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-0'
                    : 'border border-gray-100 focus-visible:border-primary'
                }`}
                type="text"
                inputMode="numeric"
                maxLength={1}
                value={digit}
                disabled={disabled || isLoading}
                onChange={(e) => handleChange(index, e.target.value)}
                onKeyDown={(e) => handleKeyDown(index, e)}
                onPaste={(e) => handlePaste(e)}
              />
            ))}
        </div>
        {hasError && (
        <div className='w-full flex flex-row items-start gap-[10px] text-left'>
            <span className="shrink-0 pt-[2px]" aria-hidden>
              <CautionDangerIcon size={18} color="#EB5757" />
            </span>
            <p className='text-[15px] leading-[22px] text-danger font-normal flex-1'>{errorMessage}</p>
        </div>
    )}
        <Button 
          type='button'
          className='w-full h-[56px]'
          onClick={handleSubmit}
          disabled={otp.some(digit => digit === '') || disabled}
          isLoading={isLoading}
        >
            Continue with login code
        </Button>
    </div>
  )
}
